<template>
  <Tooltip v-if="tooltip" :title="tooltip" side="bottom">
    <Button
      :variant="variant"
      :size="size"
      :type="type"
      icon
      :as="as"
      :asChild="asChild"
      :class="props.class"
      :disabled="disabled"
      :loading="loading"
      v-bind="$attrs"
    >
      <template #start>
        <slot />
      </template>
    </Button>
  </Tooltip>
  <Button
    v-else
    :variant="variant"
    :size="size"
    :type="type"
    icon
    :as="as"
    :asChild="asChild"
    :class="props.class"
    :disabled="disabled"
    :loading="loading"
    v-bind="$attrs"
  >
    <template #start>
      <slot />
    </template>
  </Button>
</template>

<script setup>
import { Button } from "@/SharedComponents/Buttons";
import { Tooltip } from "@/SharedComponents/Tooltips";

const props = defineProps({
  variant: { type: null, required: false },
  type: { type: String, required: false },
  size: { type: null, required: false },
  as: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  class: { type: null, required: false },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, required: false },
  tooltip: { type: String, required: false },
});
</script>
